module.exports = __webpack_public_path__ + "static/avatar-05eadefb009026a767e59a2f2c2b8bbb.jpg";